import { render, staticRenderFns } from "./AlertaNotificacao.vue?vue&type=template&id=731654a6&scoped=true&"
import script from "./AlertaNotificacao.vue?vue&type=script&lang=js&"
export * from "./AlertaNotificacao.vue?vue&type=script&lang=js&"
import style0 from "./AlertaNotificacao.vue?vue&type=style&index=0&id=731654a6&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "731654a6",
  null
  
)

export default component.exports